const STORE_URL_POLL_INTERVAL_MS = 100;
const STORE_URL_POLL_TIMEOUT_MS = 5000;

/**
 * Resolve the current Shopify store URL from the globals populated by Redo's
 * `env` snippet or the Shopify theme. All sources are optional, so this can
 * return undefined when none of them has run yet.
 */
export function getStoreUrl(): string | undefined {
  return (
    globalThis.redoStorefront?.storeUrl ??
    globalThis.redoStorefrontStaging?.storeUrl ??
    globalThis.Shopify?.shop ??
    globalThis.Shopify?.Checkout?.apiHost
  );
}

/**
 * Extension entries load with `async`, so on themes that lazy-load inline
 * scripts (e.g. `type="text/lazyload"`) an entry can execute before the `env`
 * snippet or the Shopify global has run. Poll briefly for a store URL instead
 * of racing those scripts.
 */
export async function waitForStoreUrl(): Promise<string | undefined> {
  const deadline = Date.now() + STORE_URL_POLL_TIMEOUT_MS;
  while (Date.now() < deadline) {
    const storeUrl = getStoreUrl();
    if (storeUrl) {
      return storeUrl;
    }
    await new Promise((resolve) =>
      setTimeout(resolve, STORE_URL_POLL_INTERVAL_MS),
    );
  }
  return getStoreUrl();
}
